import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  supplierInformation: {
    defaultMessage: 'Supplier information',
    id: 'fCfH2S',
    description: 'Supplier information header text',
  },
  purchaseOrderId: {
    defaultMessage: 'Purchase Order ID',
    id: 'S9hO04',
    description: 'Label for purchase order ID',
  },
  referenceNumber: {
    defaultMessage: 'Reference number',
    id: '9g3w3p',
    description: 'Reference number label',
  },
  selectSupplier: {
    defaultMessage: 'Select supplier',
    id: '+GlY+g',
    description: 'Select supplier dropdown default title',
  },
  selectWarehouse: {
    defaultMessage: 'Select destination',
    id: 'LVYEug',
    description: 'Select warehouse dropdown default title',
  },
  selectPaymentTerms: {
    defaultMessage: 'Select terms',
    id: 'tTtvBY',
    description: 'Select payment terms dropdown default title',
  },
  selectCurrency: {
    defaultMessage: 'Select Currency',
    id: 'eK/oI+',
    description: 'Select currency dropdown default title',
  },
  selectCarrier: {
    defaultMessage: 'Select carrier',
    id: 'Ama0Vh',
    description: 'Select carrier dropdown default title',
  },
  shippingDetails: {
    defaultMessage: 'Shipping Details',
    id: 'OkPxE2',
    description: 'Shipping details header text',
  },
  trackingNumber: {
    defaultMessage: 'Tracking number',
    id: 'U563HD',
    description: 'Tracking number label',
  },
  shippingCarrier: {
    defaultMessage: 'Shipping Carrier',
    id: 'Uqnw2u',
    description: 'Shipping carrier label',
  },
  currency: {
    defaultMessage: 'Currency',
    id: 'abgnvB',
    description: 'Currency label',
  },
  paymentTerms: {
    defaultMessage: 'Payment terms',
    id: '2LBWvI',
    description: 'Payment terms label',
  },
  paymentStatus: {
    defaultMessage: 'Payment status',
    id: 'z/MV5k',
    description: 'Payment status label',
  },
  selectPaymentStatus: {
    defaultMessage: 'Select status',
    id: 'SG6OUx',
    description: 'Select payment status dropdown default title',
  },
  orderIdLabel: {
    defaultMessage: 'Order ID',
    id: 'PJh5rt',
    description: 'Label for order ID placeholder',
  },
  noteToSupplier: {
    defaultMessage: 'Note to supplier',
    id: 'ebZfWA',
    description: 'Note to supplier label',
  },
  orderDate: {
    defaultMessage: 'Order date',
    id: 'iKbCbx',
    description: 'Order date label',
  },
  expectedDeliveryDate: {
    defaultMessage: 'Expected delivery date',
    id: '8ByqaX',
    description: 'Expected delivery date label',
  },
  addProducts: {
    defaultMessage: 'Add products',
    id: '14upnk',
    description: 'Add products button text',
  },
  products: {
    defaultMessage: 'Products',
    id: '5xqFRx',
    description: 'Products header text for read-only mode',
  },
  duplicate: {
    defaultMessage: 'Duplicate',
    id: 'zcbyj6',
    description: 'Duplicate purchase order button text',
  },
  addSupplier: {
    defaultMessage: 'Add supplier',
    id: 'SbYfOg',
    description: 'Add supplier button text',
  },
  editSupplier: {
    defaultMessage: 'Edit supplier',
    id: 'o9qQYf',
    description: 'Edit supplier button text',
  },
  unknownSku: {
    defaultMessage: 'Unknown',
    id: '0HWW+x',
    description: 'Text shown when a product has no SKU in error messages',
  },
  productErrorsFormat: {
    defaultMessage: 'SKU: {sku}, Errors: {errorMessages}',
    id: '0eKiP9',
    description: 'Format for displaying multiple validation errors for a product',
  },
});
